export default "__VITE_ASSET__B9r9UL9g__"